// Native
import { useState } from "react"

// Components
import { Button, Divider, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useToast } from "@chakra-ui/react"
import { Form } from "components"

// Config
import { API } from "config"

export default function Authenticate({ onSuccess = () => {}, ...props }){

    const toast = useToast()
    const [ password, setPassword ] = useState()
    const [ errors, setErrors ] = useState()
    const [ loading, setLoading ] = useState(false)

    const onSubmit = async () => {
        setLoading(true)

        try{
            await API.post('/employees/authenticate', { password })
            toast({ description: 'Autenticação realizada com sucesso', status: 'success', position: 'bottom-right', duration: 1000 })
            onSuccess()
            props.onClose()
        }catch(err){
            setErrors(err?.response?.data?.errors)
            toast({ title: 'A autenticação falhou. Tente novamente.', description: err?.response?.data?.message, status: 'error' })
        }

        setLoading(false)
    }

    return(
    <Modal closeOnOverlayClick={!loading} {...props}>
        <ModalOverlay />
        <ModalContent>
            <ModalHeader children="🔑 Autenticação necessária" />
            <ModalBody>
                Para realizar a ação solicitada, precisamos que insira novamente a sua senha de acesso.
                <Divider my={4} />

                <Form.Form onSubmit={onSubmit}>

                    <Form.Password 
                        required
                        label="Insira a sua senha:"
                        placeholder="•••••••"
                        size="lg"
                        isDisabled={loading}
                        error={errors?.password}
                        onChange={e => setPassword(e.target.value)}
                    />

                    <Button colorScheme="orange" isLoading={loading} type="submit" size="lg" children="Continuar" />
                </Form.Form>
            </ModalBody>
            <ModalFooter>

            </ModalFooter>
        </ModalContent>
    </Modal>
    )
}